<template>
  <component :is="multiple?'in_rq_mlt_combobox':'in_rq_combobox'"
    :md="md || 4"
    :disabled="disabled"
    :get_name="ca_get_name"
    :value.sync="t_value"
    :obj_val.sync="t_obj_val"
    :searched.sync="searched"
    :search_not_found.sync="snf"
    :value_not_found.sync="vnf"
    label="Nombre del BCEI"
    :item_text_fun="item_text_fun"
    :search_ex_filter="c_search_ex_filter"
    :main_name="ca_main_name"
    main_kf="ae__id"
    :p_icon="p_icon"
    :view_only="view_only"
    :max="max"
    k_f="f__name_similarity">
    <!-- para multiple tengo q hacer otro componenete como el combobox rq. hay un filtro q busca por lista de acs -->
    <template slot="top" v-if="!disabled">
      <fs1-tooltip text="Ingrese nombre del BCEI existente al cual desea asociar un repuesto crítico/Critical Spare Part."/>
      <fs1-span style="color:grey;font-size:9px">*solo aprobados</fs1-span>
      <!-- si se usa el dialogo se pierde el foco, lo que gatilla el cambio en el compoenete y termina agregando lo que no se encontro como string a la lista(puse un filtro para solo agregar objetos) -->
      <!-- <v-dialog v-model="snf" persistent max-width="400">
        <v-card class="pa-20 textAlignCenter">
          <h2 class="dark-orange--text">Advertencia</h2>
          <br>
          <br>
          <v-icon class="pulse_warning">warning</v-icon>
          <fs1-span>El Activo Crítico "{{searched}}" no se encuentra registrado en plataforma, o bien, aún se encuentra en proceso de revisión o rechazado.</fs1-span>
          <br>
          <div>
            <v-btn color="primary" @click="() => {snf = false;}">
              <span>Aceptar</span>
            </v-btn>
          </div>
        </v-card>
      </v-dialog> -->
    </template>
    <template slot="bottom" v-if="!disabled">
      <div v-if="snf">
        <v-icon class="pulse_warning">warning</v-icon>
        <fs1-span>El Activo Crítico "{{searched}}" no se encuentra registrado en plataforma, o bien, aún se encuentra en proceso de revisión o rechazado.</fs1-span>
      </div>
    </template>
  </component>
</template>

<script>
import in_rq_combobox from './in-rq-combobox';
import in_rq_mlt_combobox from './in-rq-mlt-combobox';

export default {
  components:{in_rq_combobox,in_rq_mlt_combobox},
  props:{
    view_only:{},
    alt_name:{},
    md:{},
    p_icon:{},
    disabled:{},
    value:{},
    obj_val:{},
    multiple:{},
    max:{},
    chips:{},
    ae__state:{default:()=>[2]},
    i_search_ex_filter:{default:()=>({})},
    item_text_fun_n:{default:1},
  },
  data(){
    return {
      vnf:false,
      snf:false,
      t_value:{},
      t_obj_val:{},
      searched:'',
      d_search_ex_filter:{},
    }
  },
  computed:{
    ca_main_name(){return this.alt_name || 'critical_asset'},
    ca_get_name(){return this.alt_name || 'critical_asset'},
    c_search_ex_filter(){
      Object.assign(this.d_search_ex_filter,{ae__state:this.j(this.ae__state),discharge_date__isnull:true},this.i_search_ex_filter);
      /* this.dev_log('this.d_search_ex_filter',this.d_search_ex_filter) */
      return this.d_search_ex_filter
    }
  },
  created(){
    this.t_value = this.value;
    this.t_obj_val = this.obj_val;
  },
  watch: {
    'obj_val'(v){this.t_obj_val = v},
    'value'(v){this.t_value = v},
    't_obj_val'(v){this.$emit('update:obj_val', v)},
    't_value'(v){this.$emit('update:value', v)},
    'snf'(snf){this.dev_log({snf})}
  },
  methods: {
    item_text_fun(i,n){ return this['item_text_fun_'+this.item_text_fun_n](i,n) },
    item_text_fun_1(i,n){
      if (i[n]) return i.state==4 ? `${i[n]} (Simulación)` : `${i[n]} (${(i.organization_obj||{}).name})`;
      return ;
    },
    item_text_fun_2(i,n){
      if (i[n]) return i.state==4 ? `${i[n]} (Simulación)` : `${i[n]} (${i.organization?.name})`;
      return ;
    }
  },
};
</script>
